import React from 'react';
import './cta.css'
const CTA = (props) => {
    return ( 
        <button className='cta'   onClick={props.onClick} >
                <h2 className='cta-text'>{props.title}</h2>
        </button>
     );
}
 
export default CTA;